import { render, staticRenderFns } from "./FormBuilderArea.vue?vue&type=template&id=a504f4ee&"
import script from "./FormBuilderArea.vue?vue&type=script&lang=js&"
export * from "./FormBuilderArea.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderArea.vue?vue&type=style&index=0&id=a504f4ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports